/* CRO J1 Phase 1 (28 Oct 2026): cart suggestion row, free bottle gift, product page perks refresh, signup bar while cart open.
   Config comes from window.CROCART (snippets/cro-assets.liquid). The gift logic stays dormant until a gift product is set
   in Theme settings > CRO cart and gift and the offer switch is on. */
(function () {
  'use strict';
  var C = window.CROCART || {};
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CRO': '1' };
  var nativeFetch = window.fetch.bind(window);
  /* Market root (30 Oct): "/" on earthswater.com.au and .co.nz, "/en-eu/", "/en-uk/" or "/en-sg/" on the subfolder markets.
     Cart calls and links are built from it so the shopper stays in their market and currency. */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Watch every cart change made on the page (theme, apps, quick add), so the gift and perks stay right even when
     theme.pubsub is not ready or an app changes the cart without telling the theme. Our own calls carry X-CRO. */
  var changedT = null;
  function cartChanged() {
    clearTimeout(changedT);
    changedT = setTimeout(function () { syncGift(); refreshPerks(); }, 350);
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = init && init.headers;
    var mine = h && (h['X-CRO'] || (typeof h.get === 'function' && h.get('X-CRO')));
    var res = nativeFetch(input, init);
    if (!mine && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) res.then(cartChanged, function () {});
    return res;
  };

  /* Suggestion-row adds go through window.fetch so other apps that watch cart requests (the shipping protection widget
     rewrites the subtotal) see them and refresh. Gift adds and removes are $0, so they stay quiet (nativeFetch): when the
     widget reacted to them it re-drew the cart from a stale copy and the suggestion row went missing for a minute or two.
     The X-CRO header stops our own watcher re-running either way. */
  function post(url, body, quiet) {
    var f = quiet ? nativeFetch : window.fetch;
    return f(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'cart error'); e.data = j; throw e; } return j; });
    });
  }
  function getCart() { return nativeFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json', 'X-CRO': '1' } }).then(function (r) { return r.json(); }); }

  /* Re-render the drawer, cart page and cart count the same way the theme does after a quantity change. */
  function refresh(source) {
    var quiet = source === 'cro-gift';
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    sections = sections.filter(function (s, i) { return s && sections.indexOf(s) === i; });
    return post(ROOT + 'cart/update.js', { updates: {}, sections: sections }, quiet).then(function (cart) {
      if (window.theme && theme.pubsub && sections.length) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: source, cart: cart });
      } else {
        /* Nothing on the page to re-draw (e.g. the empty cart page): reload so the new item shows. */
        location.reload();
      }
      return cart;
    });
  }

  /* Measurement (29 Oct): every suggestion add carries a hidden line property _cro_src (gap to free shipping "ship",
     gap to the bottle "gift", filters-only add-on "xsell", 3 month plan "plan", 12 month upgrade "swap", empty cart "empty").
     Shopify keeps it on the order line, so orders can be counted by source. Shown rows and adds also go to Microsoft Clarity
     as events and to Shopify customer events (for a GA4 custom pixel later). */
  function track(name, data) {
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  var seen = {};
  function trackShown() {
    document.querySelectorAll('[data-cro-act][data-src]').forEach(function (b) {
      if (!b.offsetParent) return;
      var k = b.getAttribute('data-src') + ':' + b.getAttribute('data-id');
      if (seen[k]) return;
      seen[k] = 1;
      track('cro_row_shown_' + b.getAttribute('data-src'), { variant_id: b.getAttribute('data-id') });
    });
  }

  /* Suggestion row buttons */
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-cro-act]');
    if (!btn) return;
    ev.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-busy');
    var act = btn.getAttribute('data-cro-act');
    var id = parseInt(btn.getAttribute('data-id'), 10);
    var src = btn.getAttribute('data-src') || 'other';
    var props = { _cro_src: src };
    track('cro_add_' + src, { variant_id: id });
    var p;
    if (act === 'add') {
      var it = { id: id, quantity: 1, properties: props };
      var plan = btn.getAttribute('data-plan');
      if (plan) it.selling_plan = parseInt(plan, 10);
      p = post(ROOT + 'cart/add.js', { items: [it] });
    } else if (act === 'swap') {
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      var key = btn.getAttribute('data-key');
      p = post(ROOT + 'cart/add.js', { items: [{ id: id, quantity: qty, properties: props }] }).then(function () { return post(ROOT + 'cart/change.js', { id: key, quantity: 0 }); });
    } else { return; }
    p.then(function () { return refresh('cro-upsell'); }).catch(function () { location.reload(); });
  });

  /* Free bottle gift */
  var busy = false, again = false, lastHad = null, ourRemoval = false, fails = 0;
  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function giftLive() { return !!(C.giftOn && C.giftVid && C.giftAvail); }

  /* Shipping protection (29 Oct, Carlos: the fee counts toward free shipping, as it does at checkout). The app adds its fee as a
     cart line only at checkout, so the fee is worked out here the same way the app does (snippets/cro-prot-fee.liquid has the
     Liquid twin): a percentage of the cart, rounded up to the app's price ladder. Not counted when the setting is off, when the
     shopper switched protection off (cart attribute _cro_prot = off) or when the protection line is already in the cart. */
  var P = C.prot || {};
  function protFee(amount, cart) {
    if (!P.on || amount <= 0) return 0;
    if (cart.attributes && cart.attributes._cro_prot === 'off') return 0;
    if (cart.items.some(function (i) { return i.handle === 'shipping-insurance'; })) return 0;
    var p = amount * P.pct / 100, f = p <= P.min ? P.min : P.min + Math.ceil((p - P.min) / P.step) * P.step;
    return Math.min(f, P.max);
  }
  /* Keep the cart attribute in step with the protection switch, then re-draw the cart so the bar, shipping line and rows count
     (or stop counting) the fee. Goes through window.fetch so the protection widget sees it and redraws the subtotal. */
  var protBusy = false;
  function syncProt() {
    var sw = document.querySelector('.ship-insurance #tm_switch_btn, .ship-insurance input[type="checkbox"]');
    if (!sw || !P.on || protBusy) return;
    var want = sw.checked ? 'on' : 'off';
    protBusy = true;
    getCart().then(function (cart) {
      var have = (cart.attributes && cart.attributes._cro_prot) || 'on';
      if (have === want) return;
      return post(ROOT + 'cart/update.js', { attributes: { _cro_prot: want } }, true).then(function () { return refresh('cro-prot'); });
    }).catch(function () {}).then(function () { protBusy = false; });
  }
  /* The widget sets the switch itself on click and fires no change event, so watch clicks too. */
  ['click', 'change'].forEach(function (type) {
    document.addEventListener(type, function (ev) {
      if (ev.target && ev.target.closest && ev.target.closest('.ship-insurance')) setTimeout(syncProt, 400);
    }, true);
  });

  function syncGift() {
    /* Runs whenever a gift product is set. With the offer switched off (or the bottle out of stock) it only removes a gift
       that is already in the cart, and never adds one. */
    if (!C.giftVid) return;
    var live = giftLive();
    if (busy) { again = true; return; }
    busy = true;
    getCart().then(function (cart) {
      var lines = cart.items.filter(function (i) { return i.variant_id === C.giftVid; });
      var has = lines.length > 0;
      var qty = lines.reduce(function (s, i) { return s + i.quantity; }, 0);
      var base = cart.total_price - lines.reduce(function (s, i) { return s + i.final_line_price; }, 0);
      base += protFee(base, cart);
      var blocked = cart.items.some(function (i) { return (C.block || []).indexOf(i.product_id) > -1; });
      var declined = ls('cro_gift_declined') === cart.token;
      if (live && lastHad === true && !has && !ourRemoval && base >= C.giftMin) { ls('cro_gift_declined', cart.token); declined = true; }
      ourRemoval = false;
      /* R2 item 6 (4 Nov): dropping under the threshold clears a removal, so getting back over it counts as a fresh qualification
         and the bottle comes back. While the cart qualifies and the bottle was removed, the cart bar offers "Add my free bottle". */
      if (declined && base < C.giftMin) { ls('cro_gift_declined', ''); declined = false; }
      document.documentElement.classList.toggle('cro-gift-off', !!(live && !has && declined && !blocked && base >= C.giftMin));

      var job = null, after = has;
      if (has && (!live || base < C.giftMin || blocked)) {
        job = lines.reduce(function (pr, l) { return pr.then(function () { return post(ROOT + 'cart/change.js', { id: l.key, quantity: 0 }, true); }); }, Promise.resolve());
        ourRemoval = true; after = false;
      } else if (has && qty > 1) {
        job = lines.reduce(function (pr, l, n) { return pr.then(function () { return post(ROOT + 'cart/change.js', { id: l.key, quantity: n === 0 ? 1 : 0 }, true); }); }, Promise.resolve());
        after = true;
      } else if (live && !has && base >= C.giftMin && !blocked && !declined && cart.item_count > 0) {
        job = post(ROOT + 'cart/add.js', { items: [{ id: C.giftVid, quantity: 1, properties: { _cro_gift: '1' } }] }, true);
        after = true;
      }
      /* Only record the new state once the change has gone through, so a failed add is never read as the customer removing the gift. */
      if (job) return job.then(function () { lastHad = after; return refresh('cro-gift'); });
      lastHad = after;
    }).then(function () { fails = 0; }, function () {
      /* A dropped request must not leave the gift in a cart that no longer qualifies: try again, up to twice. */
      if (fails++ < 2) again = true;
    }).then(function () {
      busy = false;
      if (again) { again = false; setTimeout(syncGift, fails ? 1500 : 50); }
    });
  }

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('[data-cro-gift-add]');
    if (!a) return;
    ev.preventDefault();
    ls('cro_gift_declined', '');
    lastHad = null;
    document.documentElement.classList.remove('cro-gift-off');
    track('cro_gift_readd', {});
    syncGift();
  });

  /* Promo pill (Nov 2026): cro-cartbar renders <template data-cro-promo> with each sale line's pill and struck compare-at price,
     plus the savings row and no-code note. Placed here on every cart re-render (same pattern as the plan lines in cro-bb.js). */
  function decoratePromo() {
    document.querySelectorAll('template[data-cro-promo]').forEach(function (t) {
      var root = t.closest('.shopify-section') || t.closest('cart-drawer') || document;
      var c = t.content;
      c.querySelectorAll('i[data-k]').forEach(function (d) {
        var k = d.getAttribute('data-k');
        root.querySelectorAll('[id="CartDrawer-Item-' + k + '"], [id="CartItem-' + k + '"]').forEach(function (line) {
          var meta = line.querySelector('.cro-li__meta');
          if (!meta) return;
          var pill = d.querySelector('.cro-promo-li');
          if (pill && !line.querySelector('.cro-promo-li')) meta.insertAdjacentElement('afterend', pill.cloneNode(true));
          var was = d.getAttribute('data-s'), pp = meta.querySelector('.cro-li__pp');
          if (was && pp && !meta.querySelector('s.cro-promo-s')) {
            var s = document.createElement('s'); s.className = 'cro-promo-s'; s.textContent = was;
            pp.insertAdjacentElement('beforebegin', s); pp.insertAdjacentText('beforebegin', ' ');
          }
        });
      });
      var src = c.querySelector('[data-cro-promo-sum]'), html = src ? src.innerHTML.trim() : '';
      var have = root.querySelectorAll('.cro-promo-sum, .cro-promo-nc');
      if (root.getAttribute && (root.getAttribute('data-cro-ps') !== html || (html && !have.length))) {
        have.forEach(function (e) { e.remove(); });
        var st = root.querySelector('.cro-stl.totals:not(.cro-promo-sum)');
        if (html && st) st.insertAdjacentHTML('afterend', html);
        root.setAttribute('data-cro-ps', html);
      }
    });
  }
  /* Free bottle value (4 Nov): the gift line's struck price shows the Urban bottle's listed price (data-cro-worth on the
     cart bar, from snippets/cro-gift-worth), not the gift product's own compare-at, so it follows price changes. */
  function giftWorth() {
    document.querySelectorAll('[data-cro-cartbar][data-cro-worth]').forEach(function (bar) {
      var w = bar.getAttribute('data-cro-worth'), root = bar.closest('.shopify-section') || document;
      if (!w) return;
      root.querySelectorAll('.is-cro-gift .cro-li__meta s').forEach(function (s) { if (s.textContent !== w) s.textContent = w; });
    });
  }
  var promoQ = false;
  function queuePromo() { if (promoQ) return; promoQ = true; requestAnimationFrame(function () { promoQ = false; decoratePromo(); giftWorth(); }); }
  decoratePromo(); giftWorth();
  document.addEventListener('DOMContentLoaded', function () { decoratePromo(); giftWorth(); });
  new MutationObserver(queuePromo).observe(document.documentElement, { childList: true, subtree: true });

  /* Product page perks: re-render after the cart changes (the theme already re-renders them on option change). */
  var perksTimer = null;
  function refreshPerks() {
    clearTimeout(perksTimer);
    perksTimer = setTimeout(function () {
      document.querySelectorAll('[data-cro-perks]').forEach(function (el) {
        var host = el.closest('[id^="Price-"]');
        if (!host) return;
        var m = host.id.match(/^Price-(.+)-(\d+)$/);
        if (!m) return;
        var form = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        var url = location.pathname + '?section_id=' + encodeURIComponent(m[1]) + (form && form.value ? '&variant=' + form.value : '');
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#' + CSS.escape(host.id) + ' [data-cro-perks]');
          var cur = document.querySelector('#' + CSS.escape(host.id) + ' [data-cro-perks]');
          if (fresh && cur) cur.outerHTML = fresh.outerHTML;
        }).catch(function () {});
      });
    }, 250);
  }

  function onCartUpdate(ev) {
    var src = ev && ev.source;
    if (src !== 'cro-gift') cartChanged(); else refreshPerks();
    setTimeout(trackShown, 400);
  }

  /* Market links (30 Oct): on a subfolder market, add the prefix to any plain "/..." link drawn after the page loaded (cart drawer
     refreshes, app widgets). The page itself is fixed on the server by snippets/cro-mkt-links.liquid. */
  var KEEP = /^\/(en-eu|en-uk|en-sg)(\/|\?|#|$)/;
  function fixLink(a) {
    var h = a.getAttribute('href');
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/' || h.indexOf('/cdn/') === 0 || KEEP.test(h)) return;
    a.setAttribute('href', ROOT + h.slice(1));
  }
  function fixLinks(root) { (root || document).querySelectorAll('a[href^="/"]').forEach(fixLink); }
  if (ROOT !== '/') {
    var linkT = null;
    new MutationObserver(function () { clearTimeout(linkT); linkT = setTimeout(fixLinks, 60); })
      .observe(document.documentElement, { childList: true, subtree: true });
    /* Last guard: a link clicked before the observer ran. */
    document.addEventListener('click', function (ev) { var a = ev.target.closest && ev.target.closest('a[href^="/"]'); if (a) fixLink(a); }, true);
  }

  function boot() {
    if (ROOT !== '/') fixLinks();
    var tries = 0;
    (function sub() {
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      else if (tries++ < 40) setTimeout(sub, 250);
    })();
    document.addEventListener('cart:refresh', cartChanged);
    syncGift();
    trackShown();
    /* The widget draws itself after load; check the switch once it is there (it remembers a shopper's choice). */
    setTimeout(syncProt, 2500);
    var cd = document.querySelector('cart-drawer');
    if (cd) new MutationObserver(function () { if (cd.hasAttribute('open')) setTimeout(trackShown, 300); }).observe(cd, { attributes: true, attributeFilter: ['open'] });

    /* Phone sticky add to cart: short product title (text before " - "), full title kept for desktop */
    document.querySelectorAll('product-sticky-form .product-sticky-form__variant p.text-base').forEach(function (p) {
      if (p.querySelector('.cro-st-full')) return;
      var full = p.textContent.trim();
      var short = full.split(' - ')[0];
      p.innerHTML = '';
      var a = document.createElement('span'); a.className = 'cro-st-full'; a.textContent = full;
      var b = document.createElement('span'); b.className = 'cro-st-short'; b.textContent = short;
      p.appendChild(a); p.appendChild(b);
    });

    /* Shipping protection price: "($9)" reads "$9" */
    var tidyT = null;
    var tidy = function () {
      clearTimeout(tidyT);
      tidyT = setTimeout(function () {
        document.querySelectorAll('.ship-insurance .tm_price').forEach(function (el) {
          var t = el.textContent.trim();
          if (/^\(.*\)$/.test(t)) el.textContent = t.slice(1, -1);
        });
      }, 60);
    };
    ['cart-drawer', 'main-cart', '.cart'].forEach(function (sel) {
      var host = document.querySelector(sel);
      if (host) new MutationObserver(tidy).observe(host, { childList: true, subtree: true });
    });
    tidy();

    /* Hide the signup bar (Yeps) while the cart drawer is open */
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var mark = function () {
        var open = drawer.hasAttribute('open');
        document.documentElement.classList.toggle('cro-cart-open', open);
        document.querySelectorAll('#yeps,[id^="yeps"]').forEach(function (y) {
          /* The bar lives in an open shadow root whose :host rules beat outside styles, so hide it from inside. */
          var root = y.shadowRoot;
          if (!root) { if (open) y.style.setProperty('visibility', 'hidden', 'important'); else y.style.removeProperty('visibility'); return; }
          var st = root.getElementById('cro-hide');
          if (open && !st) { st = document.createElement('style'); st.id = 'cro-hide'; st.textContent = '*{display:none!important}'; root.appendChild(st); }
          if (!open && st) st.remove();
        });
      };
      new MutationObserver(mark).observe(drawer, { attributes: true, attributeFilter: ['open'] });
      mark();
    }
  }
  /* Deferred scripts run before theme.js has set up theme.pubsub; DOMContentLoaded fires after all of them. */
  if (document.readyState === 'complete') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
